import { generateReadActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";
import ACTION_NAMES from "actions/ACTION_NAMES";

const getLeadTypes = generateReadActionCreator(routes.API_LEAD_TYPES, ACTION_NAMES.LEAD_TYPES);

export default {
    getLeadTypes
}
